export const REPORT_CATEGORIES = [
  { value: "harassment", label: "Acoso" },
  { value: "fake_profile", label: "Perfil falso" },
  { value: "inappropriate_content", label: "Contenido inapropiado" },
  { value: "spam", label: "Spam" },
  { value: "other", label: "Otro" },
];
